import React from 'react';
import { NumberInput, TextInput } from 'ui-toolkit';
import { updateEscrowComputedFields } from '../utilities/commonComputations';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import Currency from '../Currency';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import IItemProps from './IItemProps';
import ItemMetaDataModal, { IItemMetaDataModalRef } from './ItemMetaDataModal/ItemMetaDataModal';
import SharedItemCells from './SharedItemCells';
import './_EscrowAtClosing.scss';
import { IEscrowAtClosingOtherViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { isNil } from 'lodash';

interface IEscrowAtClosingOtherProps
  extends IItemProps,
    IHasItemDataProps<IEscrowAtClosingOtherViewItem>,
    Required<IHasItemEventProps<IEscrowAtClosingOtherViewItem>>,
    IHasMetaDataModalProps {}

type IEscrowAtClosingOtherState = IHasMetaDataModalState;

export default class EscrowAtClosingOther extends React.Component<
  IEscrowAtClosingOtherProps,
  IEscrowAtClosingOtherState
> {
  public state = { expanded: !this.props.disableAutoExpand && this.props.data.new };
  private modal = React.createRef<IItemMetaDataModalRef>();
  private firstInput: HTMLInputElement | null = null;

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const monthlyPayment = data.monthly_payment;
    const generateComputedOnChangeHandler = createOnChangeHandlerGenerator(
      data,
      (item: IEscrowAtClosingOtherViewItem) => onChange(updateEscrowComputedFields(item, 'buyer_at_closing'))
    );
    const monthlyPaymentOnChangeEvent = generateComputedOnChangeHandler('monthly_payment');
    const monthsOnChangeEvent = generateComputedOnChangeHandler('months');
    const labelOnChangeEvent = generateComputedOnChangeHandler('label');

    return (
      <div className="escrow-at-closing">
        <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
          <ItemMetaDataModal
            ref={this.modal}
            label={
              <span>
                {data.label} (
                <strong>
                  {isNil(monthlyPayment) ? '__.__' : <Currency value={monthlyPayment} />} /mon for{' '}
                  {isNil(data.months) ? '__' : data.months} mon
                </strong>
                )
              </span>
            }
            expanded={this.state.expanded}
            expandedLabel={
              <TextInput
                onChange={labelOnChangeEvent}
                placeholder="Payee"
                getInputRef={this.setFirstInput}
                value={data.label}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
            }
            onToggle={this.onModalToggleEvent}
          >
            <div className="escrow-at-closing__extra">
              <div className="escrow-at-closing__payment">
                <NumberInput
                  label="Rate per month"
                  mode="currency"
                  name="monthly_payment"
                  onBlur={this.onBlurEvent}
                  onChange={monthlyPaymentOnChangeEvent}
                  value={data.monthly_payment}
                  readOnly={!hasEditPermissions}
                  debounceOnValueChange
                />
              </div>
              <div className="escrow-at-closing__months">
                <NumberInput
                  label="No. of months"
                  name="months"
                  allowNegative={false}
                  onBlur={this.onBlurEvent}
                  onChange={monthsOnChangeEvent}
                  value={data.months}
                  readOnly={!hasEditPermissions}
                  debounceOnValueChange
                />
              </div>
            </div>
          </ItemMetaDataModal>
        </SharedItemCells>
      </div>
    );
  }

  private setFirstInput = (elem: HTMLInputElement) => {
    this.firstInput = elem;
  };

  private onBlurEvent = (event: React.FocusEvent) => {
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
  };

  private onModalToggleEvent = (expanded: boolean) => {
    this.setState({ expanded });
    if (this.firstInput) {
      this.firstInput.focus();
    }
  };
}
